class GoogleMap {
    constructor(mapElementId, mapOptions, markers = []) {
        this.mapElementId = mapElementId;
        this.mapOptions = this._defaultMapOptions(mapOptions);
        this.map = new google.maps.Map(document.getElementById(mapElementId), this.mapOptions);

        // Add markers if any
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();
        this.addMarkers(markers);
        this._fitMapToBounds();  // Fit the map to markers

        // Store reference to the currently open popup and the marker it belongs to
        this.currentPopup = null;
        this.currentMarker = null;
    }

    // Default map options, merged with custom options
    _defaultMapOptions(customOptions) {
        const defaultOptions = {
            center: { lat: 53.0765975, lng: 8.8092175 },  // Default center (example)
            zoom: 12,
            draggable: true,
            scrollwheel: true,
            mapTypeControl: true,
            streetViewControl: true,
            zoomControl: true,
            fullscreenControl: true,
            styles: null  // Optional: you can add custom map styles here
        };
        return { ...defaultOptions, ...customOptions };
    }

    Popup = class extends google.maps.OverlayView {
        position;
        containerDiv;
        constructor(position, content) {
            super();
            this.position = position;

            // Create the popup content
            const bubbleContent = document.createElement("div");
            bubbleContent.classList.add("popup-bubble");
            bubbleContent.appendChild(content);

            // Create an anchor for the bubble
            const bubbleAnchor = document.createElement("div");
            bubbleAnchor.classList.add("popup-bubble-anchor");
            bubbleAnchor.appendChild(bubbleContent);

            // Container for the entire popup
            this.containerDiv = document.createElement("div");
            this.containerDiv.classList.add("popup-container");
            this.containerDiv.appendChild(bubbleAnchor);

            // Prevent map hits and gestures from the popup
            google.maps.event.addDomListener(this.containerDiv, 'mousedown', function(e) {
                e.stopPropagation();
            });
        }

        /** Called when the popup is added to the map. */
        onAdd() {
            // Ensure the containerDiv is not already appended
            if (!this.containerDiv.parentElement) {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }
        }

        /** Called when the popup is removed from the map. */
        onRemove() {
            if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        }

        /** Called each frame when the popup needs to draw itself. */
        draw() {
            const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

            const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                ? "block"
                : "none";

            if (display === "block") {
                this.containerDiv.style.left = divPosition.x + "px";
                // Adjust the top position to move the popup higher than the marker
                this.containerDiv.style.top = (divPosition.y - 40) + "px"; // Shift it 40px above the marker
            }

            if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
            }
        }
    };

    addMarker(markerOptions) {
        const marker = new google.maps.Marker({
            position: markerOptions.position,
            map: this.map,
            title: markerOptions.title || '',
            icon: markerOptions.icon || null  // Optional: custom icon
        });

        // Extend bounds with marker position
        this.bounds.extend(marker.getPosition());

        // Add click event listener to show/hide the custom pop-up
        marker.addListener('click', () => {
            this.togglePopup(markerOptions, marker);
        });

        this.markers.push(marker);
    }

    // Method to show or hide the popup based on the clicked marker
    togglePopup(markerOptions, marker) {
        // If clicking on the same marker, close the popup
        if (this.currentMarker === marker) {
            this.closeCurrentPopup();
            return;
        }

        // If a different marker is clicked, close the current popup (if any) and open a new one
        if (this.currentPopup) {
            this.closeCurrentPopup();
        }

        // Create and display the new popup
        const popupContent = document.createElement("div");
        popupContent.innerHTML = `<p>${markerOptions.infoWindow.content}</p>`;

        const popup = new this.Popup(marker.getPosition(), popupContent);
        popup.setMap(this.map);  // Add the popup to the map

        // Update the currentPopup and currentMarker references
        this.currentPopup = popup;
        this.currentMarker = marker;
    }

    // Method to close the current popup if it is open
    closeCurrentPopup() {
        if (this.currentPopup) {
            this.currentPopup.setMap(null);  // Remove the popup from the map
            this.currentPopup = null;
            this.currentMarker = null;
        }
    }

    // Method to add multiple markers
    addMarkers(markers) {
        markers.forEach(marker => this.addMarker(marker));
    }

    // Method to remove all markers
    clearMarkers() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();  // Reset bounds
    }

    // Method to fit the map to the bounds of all markers
    _fitMapToBounds() {
        if (this.markers.length === 1) {
            // Center and zoom to a single marker
            this.map.setCenter(this.markers[0].getPosition());
            this.map.setZoom(this.mapOptions.zoom);
        } else if (this.markers.length > 1) {
            // Fit map to all markers
            this.map.fitBounds(this.bounds);
        }
    }

    // Method to center the map on a given position
    setCenter(lat, lng) {
        this.map.setCenter(new google.maps.LatLng(lat, lng));
    }

    // Method to zoom the map
    setZoom(zoomLevel) {
        this.map.setZoom(zoomLevel);
    }
}


function initializeGoogleMaps() {
    var mapID = $("#gmap");
    if (mapID.length) {
        const mapOptions = {
            center: {lat: 53.5511, lng: 9.9937},  // Hamburg
            zoom: map_zoom
        };
        console.log(markers);
        const googleMap = new GoogleMap('gmap', mapOptions, markers);
    }
}

function CookieGoogleMaps(status) {
    let gmap = document.getElementById("gmap");
    let clink = document.getElementById("gmap-cookie");
    if (gmap && clink) {
        if (status == "show") {
            gmap.classList.remove("hide");
            clink.classList.add("hide");
        } else {
            gmap.classList.add("hide");
            clink.classList.remove("hide");
        }
    }
}

function allowGoogleMaps(e) {
    klaro.getManager().saveAndApplyConsents();
    klaro.getManager().updateConsent("googlemaps", true);
    klaro.getManager().saveAndApplyConsents();
}

$(".el-map__project-map").hide();

$("#toggle-map").on("click",
    function (e) {
        $(".el-map__project-map").toggle(); // Toggle the map visibility
        $(this).toggleClass("active");
    }
)

